export default __webpack_public_path__ + "static/media/indexpage01.600ad5cc.jpg";